module.exports = __webpack_public_path__ + "img/orders.9cb824da.png";